<script setup>
const { t } = useI18n()
</script>

<template>
  <div class="flex grow flex-col justify-between flex-gap-y-4 whitespace-pre-wrap">
    <DSAlert
      type="danger"
      no-close
      class="w-100%"
    >
      {{ t('You are unable to register for events. Please contact us for more information') }}
    </DSAlert>

    <div class="flex flex-col flex-gap-y-2">
      <BaseLink url="/account/contact">
        <DSButton
          class="btn btn-md w-full truncate uppercase btn-fill-secondary"
        >
          {{ t('Contact Us') }}
        </DSButton>
      </BaseLink>
    </div>
  </div>
</template>

<i18n>
{
  "en-us": {
    "You are unable to register for events. Please contact us for more information": "You are unable to register for events. Please contact us for more information",
    "Contact Us": "Contact Us"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "You are unable to register for events. Please contact us for more information": "Sie können sich nicht für Veranstaltungen registrieren. Bitte kontaktieren Sie uns für weitere Informationen",
  "Contact Us": "Kontakt"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "You are unable to register for events. Please contact us for more information": "Vous ne pouvez pas vous inscrire à des événements. Veuillez nous contacter pour plus d'informations",
  "Contact Us": "Nous contacter"
}
</i18n>

<i18n locale="es" lang="json">
{
  "You are unable to register for events. Please contact us for more information": "No puede inscribirse a eventos. Póngase en contacto con nosotros para más información",
  "Contact Us": "Contactarnos"
}
</i18n>
